import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Image from "../../Tags/Image";
import Input from "../../Tags/Input";
import { Badge } from "../../ui/badge";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function SearchFilter({ searchFilter = {}, submitFilter }) {
  console.log("searchFilter", searchFilter);
  const [initialValues, setInitialValues] = useState({});
  const captureEvent = useCaptureEvent();

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      submitFilter(values);
    },
  });

  useEffect(() => {
    if (searchFilter && Object.keys(searchFilter).length > 0) {
      const updatedInitialValues = Object.keys(searchFilter).reduce((acc, key) => {
        const fieldData = searchFilter[key]; // Get the inner object
        const fieldName = key || ""; // Ensure inner object exists
        acc[fieldName] = fieldData?.value || ""; // Get the value, fallback to an empty string
        return acc;
      }, {});

      setInitialValues(updatedInitialValues); // Set initial values once object is populated
    }
  }, [searchFilter]); // Re-run the effect when searchFilter changes

  const returnImg = (key) => {
    if (key === "name") {
      return "/images/icons/untitledui/building.svg";
    }
    if (key === "social_media_urls_linkedin_url") {
      return "/images/icons/linkedin-icon.svg";
    }
    if (key === "domain") {
      return "/images/icons/untitledui/domain.svg";
    }
  };

  const [editMode, setEditMode] = useState(false);

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="mt-4 animate__animated animate__fadeIn  p-4 border border-[#D0D5DD] bg-[#F9FAFB] rounded-xl"
    >
      <div className="">
        {Object.keys(searchFilter)
          .sort((a, b) => {
            if (a === "social_media_urls_linkedin_url") return 1; // move 'a' after 'b'
            if (b === "social_media_urls_linkedin_url") return -1; // keep 'a' before 'b'
            return 0; // preserve original order
          })
          .map((key, index) => {
            const fieldData = searchFilter[key]; // Get the inner object
            const inputName = key || ""; // Ensure the inner object exists

            return (
              <div
                className={`${inputName !== "social_media_urls_linkedin_url" ? "w-6/12" : "w-full"} mb-3 inline-flex pr-2`}
              >
                {/* {inputName} */}
                {editMode ? (
                  <div className=" w-full" key={index}>
                    <p className=" text-[#344054] text-sm inline-flex items-center mb-2">
                      {fieldData?.label}
                    </p>

                    <Input
                      icon={<Image src={returnImg(inputName)} className="h-5" />}
                      type="text"
                      name={inputName}
                      className="rounded-[8px] w-full bg-white border border-[#dddddd] text-[#11181C] text-[14px] p-2 h-10"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values[inputName] || ""} // Provide a fallback empty string
                    />
                  </div>
                ) : (
                  <div
                    className="flex items-center space-x-2 bg-white border border-[#dddddd] p-3 rounded-xl cursor-pointer w-full"
                    key={index}
                    onClick={() => {
                      setEditMode(true);
                      captureEvent("ECRM_AssociateAccount_EditSearchClick", {
                        field_name: inputName,
                      });
                    }}
                  >
                    <div className=" text-[#344054] text-sm inline-flex items-center">
                      <Image src={returnImg(inputName)} className="h-5" />{" "}
                      <span className="whitespace-pre block ml-2">{fieldData?.label}</span>
                    </div>
                    {formik.values[inputName] && <Badge variant={"gray"}>{formik.values[inputName]}</Badge>}
                  </div>
                )}
              </div>
            );
          })}
      </div>
      {editMode && (
        <div className="flex items-center mt-4">
          <button
            type="submit"
            className="text-[14px] disabled:opacity-70 inline-flex justify-center items-center py-2 h-9 space-x-2 px-4 rounded-[8px] text-white bg-[#7F56D9] border border-[#7F56D9] "
          >
            <MagnifyingGlassIcon width={18} height={18} className="mr-1" />
            Search
          </button>
          <span
            onClick={() => {
              setEditMode(false);
            }}
            className="cursor-pointer inline-flex justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-transparent border-transparent text-[#475467] px-4 py-2 h-9 rounded-[8px]"
          >
            Cancel
          </span>
        </div>
      )}
    </form>
  );
}
